import { Link } from 'react-router-dom'
import styled from 'styled-components/macro'
import { Grid, GridColumn } from 'src/components/Reusable/Grid'
import { SectionTitle } from 'src/components/Reusable/Text/Text.styles'
import palette from 'src/designSystem/variables/palette'
import { ReactComponent as DeleteSVG } from 'src/components/Icons/assets/delete-icon.svg'
import { ReactComponent as AddSVG } from 'src/components/Icons/assets/add-icon.svg'
import { ReactComponent as CheckSVG } from 'src/components/Icons/Basic/icons_check.svg'
import { ReactComponent as CloseSVG } from 'src/components/Icons/assets/close-icon.svg'
import { ReactComponent as InfoSVG } from 'src/components/Icons/Basic/icons_info.svg'
import { Message } from 'src/components/Reusable/Message/Message'
import { FlexAlign } from 'src/components/Reusable/Flex'
import {
  ScopingAddOrEditButtonType,
  StyledAddOrEditButton,
} from '../Services/ServicesAddOrEditButton'
import {
  ScanReceptorButton,
  ConfigReceptorButton,
} from '../Receptors/receptors.components'

export const StyledAccountSettingsButton = styled(StyledAddOrEditButton).attrs({
  buttonType: ScopingAddOrEditButtonType.EDIT,
})`
  svg {
    width: 24px;
    height: 24px;
    path {
      fill: ${({ theme }) => theme.colors.text.icon.default};
    }
  }
  &:hover {
    svg path {
      fill: ${({ theme }) => theme.colors.fill.white};
    }
    ${({ disabled }) =>
      disabled &&
      `svg path {
            fill: ${palette.neutral[600]};
        }
  `}
  }
`

export const StyledAccountSettingsGridColumn = styled(GridColumn).attrs({
  alignItems: 'center',
  padding: '8px 16px',
  height: '56px',
})<{ justifyContent?: FlexAlign }>`
  justify-content: ${({ justifyContent }) =>
    justifyContent ? justifyContent : 'flex-start'};
`

export const AccountSettingsRowTitle = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`
export const AccountSettingsRowTitleText = styled.label`
  font-weight: 700;
  font-size: 14px;
  line-height: 150%;
  font-style: bold;
  color: ${palette.neutral[900]};
`

export const AccountSettingsRowTitleContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  button {
    width: max-content;
  }
`

export const AccountSettingsDescription = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: ${palette.neutral[800]};
  display: flex;
  width: 100%;
`

export const AccountSettingsWarning = styled.div`
  color: ${palette.orange[900]};
  font-size: 14px;
  font-weight: 500;
`

export const DateLimitInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5em;
  span {
    margin-right: 0;
  }
`

export const AccountSettingsSectionTitle = styled(SectionTitle)`
  margin: 16px 0;
`

export const AccountSettingsGrid = styled(Grid)`
  margin-bottom: 1em;
`

export const AccountSettingsLink = styled(Link)`
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
`

export const AccountSettingsRowBody = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  width: 100%;
  justify-content: space-between;
`

export const IntegrationScanButton = styled(ScanReceptorButton)`
  button {
    height: 900px;
    width: 9px;
  }
`
export const IntegrationConfigButton = styled(ConfigReceptorButton)`
  button {
    height: 900px;
    width: 9px;
  }
`

export const DeleteIcon = styled(DeleteSVG)<{ rightmargin?: string }>`
  width: 16px;
  height: 16px;
  margin-right: ${({ rightmargin }) => rightmargin || '0'};
`

export const AddIcon = styled(AddSVG)`
  width: 16px;
  height: 16px;
`
export const CheckIcon = styled(CheckSVG)`
  width: 16px;
  height: 16px;
`
export const CloseIcon = styled(CloseSVG)`
  width: 16px;
  height: 16px;
`
export const DepartmentContainer = styled.div`
  display: grid;
  grid-template-columns: 60px auto;
`
export const AccountSettingsGridRows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`
export const InfoIcon = styled(InfoSVG)`
  width: 16px;
  height: 16px;
`

export const AccountSettingMessage = styled(Message)`
  padding: 0 !important;
`

export const AddButtonTextButton = styled.button`
  color: #00aac4;
  text-align: right;
  font-size: 14px;
  font-weight: 500;
  line-height: 100%;
  letter-spacing: 0.05px;
  text-transform: uppercase;
  background: none;
  border: none;
  cursor: pointer;
  margin-top: 16px;
`
